module.exports = __webpack_public_path__ + "static/media/Anonimo.45eecc1e.svg";